const INLINE_DISAMBIGUATION_MAX_LENGTH = 24;

export function getWorkDisambiguationDisplay(
  title: string,
  disambiguation: string | null | undefined,
) {
  const value = disambiguation?.trim();
  if (!value) return null;
  if (isDisambiguationAlreadyInTitle(title, value)) return null;
  return value;
}

export function shouldRenderWorkDisambiguationInline(disambiguation: string) {
  return disambiguation.length <= INLINE_DISAMBIGUATION_MAX_LENGTH;
}

export function formatWorkTitleWithDisambiguation(
  title: string,
  disambiguation: string | null | undefined,
) {
  const displayDisambiguation = getWorkDisambiguationDisplay(title, disambiguation);
  return displayDisambiguation ? `${title} (${displayDisambiguation})` : title;
}

function isDisambiguationAlreadyInTitle(title: string, disambiguation: string) {
  const normalizedTitle = normalizeTitleText(title);
  const normalizedDisambiguation = normalizeTitleText(disambiguation);

  if (normalizedTitle === normalizedDisambiguation) return true;

  const wrappedDisambiguations = [
    `(${normalizedDisambiguation})`,
    `[${normalizedDisambiguation}]`,
    `{${normalizedDisambiguation}}`,
  ];

  if (wrappedDisambiguations.some((wrapped) => normalizedTitle.endsWith(wrapped))) {
    return true;
  }

  return normalizedDisambiguation.length > 3 && normalizedTitle.includes(normalizedDisambiguation);
}

function normalizeTitleText(value: string) {
  return value
    .trim()
    .toLocaleLowerCase()
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\s+/g, " ");
}
